const config = JSON.parse(document.querySelector('[data-commerce-rules-config]')?.textContent ?? '{}');
const rules = {
  enabled: config.enabled !== false,
  threshold: Number(config.threshold || 0),
  lowStockThreshold: Number(config.lowStockThreshold || 3)
};

const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en', {
  style: 'currency', currency: window.Shopify?.currency?.active || config.currency || 'EUR'
}).format(cents / 100);

function paintShipping(root = document) {
  if (!rules?.enabled) return;
  root.querySelectorAll('[data-shipping-progress]').forEach((bar) => {
    const total = Number(bar.dataset.cartTotal || 0);
    const threshold = Number(rules.threshold || 0);
    const remaining = Math.max(0, threshold - total);
    const label = bar.querySelector('[data-shipping-progress-label]');
    const meter = bar.querySelector('[data-shipping-progress-meter]');
    if (label) label.textContent = threshold === 0 || remaining === 0
      ? config.shippingReached
      : config.shippingRemaining.replace('%amount%', money(remaining));
    if (meter) meter.style.setProperty('--progress', `${threshold <= 0 ? 100 : Math.min(100, total / threshold * 100)}%`);
    bar.hidden = false;
  });
}

function paintAvailability(variant) {
  const target = document.querySelector('[data-availability]');
  if (!target || !variant?.available || !rules?.enabled) return;
  const tracked = variant.inventory_management && variant.inventory_policy !== 'continue';
  const quantity = Number(variant.inventory_quantity);
  if (tracked && quantity > 0 && quantity <= rules.lowStockThreshold) {
    target.textContent = config.lowStock.replace('%count%', quantity);
    target.setAttribute('data-state', 'low');
  }
}

document.addEventListener('theme:cart:refresh', (event) => paintShipping(event.detail?.root || document));
document.addEventListener('theme:variant:change', (event) => paintAvailability(event.detail?.variant));
paintShipping();
const variants = JSON.parse(document.querySelector('[data-variant-data]')?.textContent ?? '[]');
const selected = document.querySelector('[data-variant-id]')?.value;
paintAvailability(variants.find(({ id }) => String(id) === String(selected)));
